import { MeasureType } from '../../../learnware/LearnwareEnums';
export class AspectMountMeasureToInnerStage {
    parent;
    measureType;
    constructor(parent, measureType = MeasureType.BoundingClientRect) {
        this.parent = parent;
        this.measureType = measureType;
    }
    get aspectMount() {
        return this.parent;
    }
    get windowMeasure() {
        if (this.measureType === MeasureType.BoundingClientRect) {
            return this.aspectMount.measureToWindowIncludingTransform;
        }
        return this.aspectMount.measureToWindow;
    }
    get stage() {
        return this.aspect.context.stage;
    }
    get stageMounted() {
        return this.stage.inner.aspectMount;
    }
    get aspect() {
        return this.parent.aspect;
    }
    get aspectTopInPixel() {
        return this.windowMeasure.aspectTopInPixel - this.stageMounted.measureToWindowIncludingTransform.aspectTopInPixel;
    }
    get aspectLeftInPixel() {
        return this.windowMeasure.aspectLeftInPixel - this.stageMounted.measureToWindowIncludingTransform.aspectLeftInPixel;
    }
    get aspectBottomInPixel() {
        return this.aspectTopInPixel + this.aspectMount.mountDimensions.aspectHeightInPixel;
    }
    get aspectRightInPixel() {
        return this.aspectLeftInPixel + this.aspectMount.mountDimensions.aspectWidthInPixel;
    }
    get aspectLeftInUnits() {
        return Math.round(this.aspectLeftInPixel / this.stage.stageInnerMeasure.stageWidthRatio);
    }
    get aspectTopInUnits() {
        return Math.round(this.aspectTopInPixel / this.stage.stageInnerMeasure.stageHeightRatio);
    }
    get aspectRightInUnits() {
        return Math.round(this.aspectRightInPixel / this.stage.stageInnerMeasure.stageWidthRatio);
    }
    get aspectBottomInUnits() {
        return Math.round(this.aspectBottomInPixel / this.stage.stageInnerMeasure.stageHeightRatio);
    }
    get aspectPositionsInPixel() {
        return {
            rightCenter: {
                left: this.aspectLeftInPixel + this.aspectMount.mountDimensions.aspectWidthInPixel,
                top: this.aspectTopInPixel + this.aspectMount.mountDimensions.aspectHeightInPixel / 2,
            },
            leftCenter: {
                left: this.aspectLeftInPixel,
                top: this.aspectTopInPixel + this.aspectMount.mountDimensions.aspectHeightInPixel / 2,
            },
            centerCenter: {
                left: this.aspectLeftInPixel + this.aspectMount.mountDimensions.aspectWidthInPixel / 2,
                top: this.aspectTopInPixel + this.aspectMount.mountDimensions.aspectHeightInPixel / 2,
            },
        };
    }
}
